"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManagedComponent = void 0;
var preact_1 = require("preact");
var styles = __importStar(require("./managed-component.scss"));
var kaltura_player_js_1 = require("@playkit-js/kaltura-player-js");
var connect = kaltura_player_js_1.ui.redux.connect;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var mapStateToProps = function (state) { return ({
    playerSize: state.shell.playerSize
}); };
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
var ManagedComponent = /** @class */ (function (_super) {
    __extends(ManagedComponent, _super);
    function ManagedComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ManagedComponent.prototype.update = function () {
        this.setState(function (prev) {
            return {
                toggler: !prev.toggler
            };
        });
    };
    ManagedComponent.prototype.shouldComponentUpdate = function (prevProps) {
        var _a = this.props, updateOnPlayerSizeChanged = _a.updateOnPlayerSizeChanged, playerSize = _a.playerSize;
        return (updateOnPlayerSizeChanged && prevProps.playerSize !== playerSize) || prevProps.playerSize === playerSize;
    };
    ManagedComponent.prototype.componentDidMount = function () {
        // eslint-disable-next-line react/no-did-mount-set-state
        this.setState({
            toggler: false
        });
    };
    ManagedComponent.prototype.render = function () {
        var _a = this.props, fillContainer = _a.fillContainer, isShown = _a.isShown, playerSize = _a.playerSize;
        if (!isShown()) {
            return null;
        }
        return ((0, preact_1.h)("div", { "data-contrib-item": this.props.label, className: "".concat(fillContainer ? styles.fillContainer : '') }, this.props.renderChildren(playerSize)));
    };
    ManagedComponent.defaultProps = {
        fillContainer: false
    };
    ManagedComponent = __decorate([
        connect(mapStateToProps, null, null, { forwardRef: true })
    ], ManagedComponent);
    return ManagedComponent;
}(preact_1.Component));
exports.ManagedComponent = ManagedComponent;
